<!-- Price breakdowns -->
@if (
  {
    basket: (basketService.getBasketStats(index) | async) || [],
    basketItems: ((basketService.baskets | async)[index].subject | async).basketItems
  };
  as data
) {
  <div class="cart_panel_total">
    <dl>
      @if (data.basket.totalCo2) {
        <div class="cart_panel_total_co2_heading">
          <dt class="basket_panel_co2_total" aria-label="CO2 Total">
            <strong i18n="@@basketCo2">CO<sub>2</sub></strong>
          </dt>
          <dd class="breakdown_co2_total">{{ data.basket.totalCo2 | number: '1.2-2' }} Kg</dd>
        </div>
      }
      @if (!hasMultipleCurrencies(data.basketItems)) {
        <div class="cart_panel_total_heading">
          <dt class="basket_panel_total" aria-label="Total">
            <strong i18n="@@basketPanelTotal">Total</strong>
          </dt>
          <dd id="basket_breakdown_total" class="breakdown_total">
            {{ data.basket.currency }} {{ data.basket.total | number: '1.2-2' }}
          </dd>
        </div>
      }
    </dl>
    <div class="total_breakdown_list_wrapper">
      <table class="total_breakdown_list">
        <caption class="visuallyhidden">
          Emissions and prices for selected items
        </caption>
        <thead>
          <tr class="total_breakdown_list-header">
            <th class="visuallyhidden" i18n="@@basketPanelType">Type</th>
            <th class="total_breakdown_item_total" i18n="@@basketCo2">CO<sub>2</sub></th>
            <th class="total_breakdown_item_total" i18n="@@basketPanelPrice">Price</th>
          </tr>
        </thead>
        <tbody>
          @for (list of data.basket.list; track list; let i = $index) {
            @if (list.price > 0) {
              <tr class="total_breakdown_item">
                <td class="total_breakdown_item_name">
                  <i aria-hidden="true" class="ico-tick-mark"></i>
                  <strong>{{ list.text | translate }}</strong>
                </td>
                <td>
                  <span class="total_breakdown_item_total">
                    @if (list.co2 > 0) {
                      <div>{{ list.co2 | number: '1.2-2' }}</div>
                    } @else {
                      N/A
                    }
                  </span>
                </td>
                <td>
                  <span class="total_breakdown_item_total">{{ list.price | number: '1.2-2' }}</span>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
    @if (data.basket.currency === 'GBP' && !hasMultipleCurrencies(data.basketItems)) {
      <div class="currency_message">
        <span i18n="@@basketPanelAllPrices">All prices shown in GBP</span>
        <div class="tooltip_wrap">
          <section (mouseleave)="tt.close()" class="container">
            <button
              type="button"
              class="currency_info_icon"
              [placement]="tooltipPlacement"
              triggers="manual"
              #tt="ngbTooltip"
              #ttBtn
              (mouseenter)="tt.open()"
              (focus)="tt.open()"
              (blur)="tt.close()"
              (click)="tt.toggle()"
              (hidden)="ttBtn.setAttribute('aria-describedby', 'currency-tooltip-' + index)"
              i18n-ngbTooltip
              ngbTooltip="All prices shown in GBP based on exchange rates we have on record."
              aria-label="Currency exchange rate info"
              i18n-aria-label="@@basketPanelCurrencyExchangeRateInfo"
              [attr.aria-describedby]="'currency-tooltip-' + index"
            ></button>
            <div
              class="visuallyhidden"
              id="currency-tooltip-{{ index }}"
              role="tooltip"
              i18n="@@basketPanelAllPricesExchangeRecord"
            >
              All prices shown in GBP based on exchange rates we have on record.
            </div>
          </section>
        </div>
      </div>
    }
  </div>
}
